import { Theme } from '@mui/material/styles';

const Container: Theme['container'] = {
  sm: '736px',
  md: '920px',
  lg: '1152px',
}

export default Container
